import * as React from "react";
import classnames from "classnames";
/* empty css           */
const Label = ({
  type,
  variant = "medium",
  className,
  children
}) => /* @__PURE__ */ React.createElement("b", { className: classnames("label", `label--${type}`, `label--${variant}`, className) }, children);
export {
  Label as default
};
//# sourceMappingURL=Label.js.map
